<template>
    <div v-if="logosCount > 1">
        <hr>
        <h3>SELECT A LOGO OPTION</h3>
        <div class="form-group row no-gutter">
            <div class="col-md-12">
                <div class="form-group row no-gutter">
                    <label class="col-sm-6 control-label">Select a preferred logo on your brick:</label>
                    <div class="col-sm-6" v-bind:class="{'has-error': errors.has('preferred_logo')}">
                        <select class="form-control"
                            name="preferred_logo"
                            v-model="prefLogo"
                            data-vv-name="preferred_logo"
                            v-validate="'required'"
                            v-on:change="onChange(prefLogo)"
                        >
                            <option value="">-- Please select a logo --</option>
                            <option v-for="(logo, logoIndex) in logosList" v-bind:value="logoIndex">
                                {{ logo.brief_descr }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/jsx">
    import { Event } from '../../../../../assets/js/components/frontend/event.vue'
    import CampaignConfigurationMixin from '../../../../../assets/js/components/frontend/mixin/campaign-configuration.vue'
    export default {
        name: 'preferred-logo',
        mixins: [
            CampaignConfigurationMixin,
        ],
        data: function () {
            return this.getDefaultData();
        },
        props: {
            options: {
                // data source
                type: Object,
                required: true
            },
            logo: {
                // initial value is provided via property
                type: String,
                required: true
            },
            onLogoChange: {
                // handler name to inform about change of preferred logo
                type: String,
                default: function () {
                    return 'onLogoChange';
                }
            }
        },
        mounted: function () {
            if (this.logosCount == 1 || this.logo === '') {
                Event.$emit(this.onLogoChange, this.firstLogo);
            }
        },
        methods: {
            getDefaultData: function () {
                return {
                    prefLogo: this.logo
                };
            },
            onChange: function (newValue) {
                Event.$emit(this.onLogoChange, newValue);
            }
        },
        computed: {
            campaign: function () {
                return this.$store.state.campaign
            },
            logosList: function () {
                var res = {};
                if (this.isMultiLogoAllowed) {
                    if ("logo" in this.options) {
                        res = this.options.logo;
                    }
                }
                return res;
            },
            logosCount: function () {
                return Object.keys(this.logosList).length;
            },
            firstLogo: function () {
                var keys = Object.keys(this.logosList);
                if (keys.length > 0) {
                    return keys[0];
                }
                return '';
            }
        }
    }
</script>



// WEBPACK FOOTER //
// preferred-logo.vue?7490bbfe